import Emergency from './Emergency'
export default Emergency
